// extracted by mini-css-extract-plugin
export default {"card":"MainCard_card__lXkFb"};